import { type TranslationTree } from '@/i18n/types';

export const messages = {
  brandTag: 'Partners',
  eyebrow: 'Para parceiros do esporte',
  signinTitle: 'Eventos, ofertas e fotos',
  signinHighlight: 'na frente de quem treina.',
  signupTitle: 'Leve a sua marca',
  signupHighlight: 'para o app de quem treina.',
} satisfies TranslationTree;
